import React, {Component} from 'react';
import ButtonConfirmDelete from './ButtonConfirmDelete'

class CameraButtonDelete extends Component {
  render() {
    const {camera, onDelete} = this.props
    const content = `Chắc chắn xoá camera ${camera.Name}?`
    return <ButtonConfirmDelete title="Xoá camera" content={content} object={camera} onOk={onDelete}/>
  }
}

export default CameraButtonDelete;



// WEBPACK FOOTER //
// ./src/components/CameraButtonDelete.js